import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

const getInitial = () => {
  try {
    const saved = localStorage.getItem("josfit_lang");
    if (saved && translations[saved]) return saved;
  } catch (e) {}
  return "fr";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitial);

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    setLangState(code);
    try {
      localStorage.setItem("josfit_lang", code);
    } catch (e) {}
  }, []);

  const value = { lang, setLang, t: translations[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "fr", setLang: () => {}, t: translations.fr };
  return ctx;
};
